import { useEffect } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import consoleLog from "../../utils/consoleLog";

import {
  selectCartItems,
  selectCartTotal,
} from "../../redux/cart/cart.selectors";
import { CartItem } from "../../redux/cart/cart.types";
import {
  // selectEstimatedTax,
  // selectEstimatedTotal,
  selectShippingPrice,
} from "../../redux/checkout/checkout.selectors";

import useStyles from "./checkout-summary.styles";

import Price from "../../components/price";

const CheckoutSummary = () => {
  const cartItems = useSelector(selectCartItems);
  const totalPrice = useSelector(selectCartTotal);
  const shippingPrice = useSelector(selectShippingPrice);
  // const estimatedTax = useSelector(selectEstimatedTax);
  // const estimatedTotal = useSelector(selectEstimatedTotal);
  const classes = useStyles();

  useEffect(() => {
    consoleLog("cartItems", cartItems);
  }, [cartItems]);

  return (
    <div className={classes.summarySection}>
      <div className={classes.summaryInner}>
        <div className={classes.summaryCart}>
          <div className={classes.cartItems}>
            {cartItems && Array.isArray(cartItems) && cartItems.length !== 0 ? (
              _.orderBy(
                [...cartItems],
                ["title", "priceSalesNow", "priceNow", "cartItemId"],
                ["asc", "desc", "desc", "asc"],
              ).map((cartItem: any, index: number) => (
                <div key={index} className={classes.cartItem}>
                  {cartItem?.defaultImage ? (
                    <img
                      src={cartItem.defaultImage}
                      className={classes.cartItemImage}
                    />
                  ) : (
                    <div className={classes.cartItemImage}>No Image</div>
                  )}
                  <div className={classes.cartItemInfo}>
                    <div className={classes.cartItemBrand}>
                      {cartItem.brand}
                    </div>
                    <div>{cartItem.title}</div>
                    <Price item={cartItem} />
                    <div className={classes.cartItemQuantity}>
                      Quantity: {cartItem.quantity}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>Shopping Bag is Empty</div>
            )}
          </div>
        </div>
        <div className={classes.discountCode}>
          {/* <form> */}
          <input
            type="text"
            id="discountCode"
            name="discountCode"
            placeholder="Enter the Discount Code"
          />
          <button>Apply</button>
          {/* </form> */}
        </div>
        <div className={classes.summaryTotal}>
          <div>
            <span>SubTotal</span>
            <span>CAD ${totalPrice.toFixed(2)}</span>
          </div>
          <div>
            <span>Shipping</span>
            <span>
              {shippingPrice
                ? `CAD $${shippingPrice.toFixed(2)}`
                : shippingPrice === 0
                ? "FREE"
                : "-"}
            </span>
          </div>
          <div>
            <span>Estimated Tax</span>
            <span>
              {/* {estimatedTax && typeof estimatedTax === "number"
                ? `CAD $${estimatedTax.toFixed(2)}`
                : "-"} */}
            </span>
          </div>
          <div className={classes.horizontalLine} />
          <div className={classes.estimatedTotal}>
            <span>Estimated Total</span>
            <span>
              {/* {estimatedTotal && typeof estimatedTotal === "number"
                ? `CAD $${estimatedTotal.toFixed(2)}`
                : "-"} */}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSummary;
